export const mapApiResponseToForm = (apiResponse = {}) => ({
  businessUnit: apiResponse?.business_unit_id, //
  name: apiResponse?.name,
  details: apiResponse?.details,
  category: apiResponse?.category_id,
  hours: apiResponse?.hours,
  searchAddress: apiResponse?.address,
  latitude: apiResponse?.lat,
  longitude: apiResponse?.lon,
  addressStreet1: apiResponse?.address_street_1,
  addressStreet2: apiResponse?.address_street_2,
  city: apiResponse?.city,
  state: apiResponse?.state,
  zipCode: apiResponse?.zip_code,
  countryCode: apiResponse?.country_code,
  handicapAccess: apiResponse?.handicap_access,
  starred: apiResponse?.starred,
  internalNotes: apiResponse?.notes, //
  coupon: apiResponse?.coupon,
})

export const mapPlacesFormToApi = (data = {}) => ({
  address: data?.searchAddress,
  address_street_1: data?.addressStreet1,
  address_street_2: data?.addressStreet2,
  business_unit_id: data?.businessUnit,
  category_id: data?.category,
  city: data?.city,
  country_code: data?.countryCode,
  coupon: data?.coupon,
  details: data?.details,
  handicap_access: data?.handicapAccess,
  hours: data?.hours,
  lat: data?.latitude,
  lon: data?.longitude,
  name: data?.name,
  notes: data?.internalNotes,
  starred: data?.starred,
  state: data?.state,
  vendor_id: data?.vendor_id,
  zip_code: data?.zipCode,
})

export const isCrohnsClient = vendorId => {
  return parseInt(vendorId) === 181
}
